import { createStandaloneToast } from '@chakra-ui/toast'

export const { toast, ToastContainer } = createStandaloneToast()
